import ButtonPrimary from "../buttons/ButtonPrimary";
import logo from '../images/logo.png';
import welcome_png from '../images/sign_up_welcome.png';
import partner_logo from '../images/partner_logo.svg';
import flower_in_hand from '../images/flower_in_hand.svg';
import { useState } from "react";
import Loader from "../Loader";
import { TranslationContextProvider } from 'schummar-translate/react';
import t from '../translations/translate.ts';
import WelcomeTo from "./WelcomeTo.js";
import { useLocale } from '../LocaleContext';

export default function SignUpWelcomePage({ familyName, letsGo }) {
    const { locale } = useLocale();
    const [welcomeState, setWelcomeState] = useState(1);
    setTimeout(() => {
        document.getElementsByClassName("bottomMenu_1")[0].style.display = "none";
        document.getElementById("route_main_div_with_bottom_menu").style.marginBottom = '0';
    }, 100);
    if (welcomeState == 1) {
        return <WelcomeTo familyName={familyName} onClick={()=> letsGo()} />
    } else if (welcomeState == 2) {
        return <TranslationContextProvider locale={locale}>
            <div 
            style={{ overflowY: 'scroll', 
                direction: localStorage.getItem('locale') == 'iw' ? 'rtl':'ltr',
                overflowX: 'hidden', height: ' calc(100%)', userSelect: 'none' }}
             onContextMenu={(e) => e.preventDefault()}>
            <div style={{ width: 180, margin: 'auto', marginTop: 10 }}>
                <img src={logo} style={{ width: 180 }} alt="logo" />
            </div>
            <div style={{ paddingTop: 20, width: 240, margin: 'auto', paddingBottom: 20 }}>
                <img style={{ width: 240 }} src={flower_in_hand} alt="hand" />
            </div>
            <div style={{ width: 280, margin: 'auto', color: 'black' }}>
                {t('theFamilyMappedOutTasks')}
                    <br /><br />
                    {t('everySmallTask')}
                    <br /><br />
                <ButtonPrimary onClick={letsGo}>{t('letsStart')}</ButtonPrimary>
                <br /><br />
            </div>
        </div></TranslationContextProvider>;
    } else return <Loader />;
}
